import Paper from "@mui/material/Paper"
import { styled } from "@mui/material/styles"
import TextField from "@mui/material/TextField"
import { colors, fonts, sizeStyles } from "@/components/shared/Dropdown/styles"
import { Variant } from "@/types/index"

const { fontSize, fontWeight, lineHeight } = sizeStyles[Variant.DEFAULT]

export const StyledTextField = styled(TextField)({
   ".MuiInputBase-root.MuiInput-root": {
      backgroundColor: colors.softWhite,
      border: `1px solid ${colors.grayBorder}`,
      borderRadius: "4px",
      padding: "7px 32px 7px 12px",
      fontFamily: fonts.rubik,
      fontSize,
      fontWeight,
      lineHeight: "1.14",
      color: colors.text,
   },
   ".MuiInputBase-root.MuiInput-root .MuiInputBase-input": {
      padding: 0,
      height: "auto",
      lineHeight: "inherit",
   },
   ".MuiAutocomplete-endAdornment": {
      right: "12px",
   },
   ".MuiAutocomplete-popupIndicator": {
      padding: 0,
      color: colors.arrowIcon,
      "&:hover": {
         backgroundColor: "unset",
      },
   },
})

export const StyledPaper = styled(Paper)({
   backgroundColor: colors.white,
   marginTop: "4px",
   boxShadow: "none",
   ".MuiAutocomplete-listbox, .MuiAutocomplete-noOptions": {
      border: `1px solid ${colors.grayBorder}`,
      borderRadius: "4px",
      padding: "7px 12px",
      fontFamily: fonts.rubik,
      fontSize,
      fontWeight,
      lineHeight,
      color: colors.text,
   },
   ".MuiAutocomplete-noOptions": {
      color: colors.placeholder,
   },
   ".MuiAutocomplete-listbox .MuiAutocomplete-option": {
      padding: 0,
      minHeight: "unset",
      "&.Mui-focused, &[aria-selected='true'], &[aria-selected='true'].Mui-focused":
         {
            backgroundColor: "unset",
         },
      "&.Mui-focused": {
         color: colors.textMenuItemHover,
      },
      "&[aria-selected='true']": {
         color: colors.textMenuItemSelected,
      },
      "&[aria-selected='true'].Mui-focused": {
         color: colors.textMenuItemSelectedHover,
      },
   },
})
